import Vue from 'vue';
import equipmentTransformer from '../../transformers/equipment';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(equipmentTransformer.fetch(errors));
};

export default (id, equipment) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/production/equipment/${id}`, equipment)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/equipment/update.js